import script from "./SettingsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsPage.vue?vue&type=script&setup=true&lang=js"

import "./SettingsPage.vue?vue&type=style&index=0&id=7821a9bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7821a9bc"]])

export default __exports__